import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initRollbar } from "./utils/rollbar";

// Initialize Rollbar for error tracking
initRollbar();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
